import { Controller } from 'react-hook-form';
import { SimpleSelect } from 'corso-admin-ui';
import { useAutomationFormContext } from '~/features/settings/automations/hooks/useAutomationForm';
import { useMerchantPaidProtectUnits } from '~/features/settings/automations/hooks/useMerchantPaidProtectUnits';
import { formatter } from 'corso-web-lib';

export default function EventMerchantPaidProtection() {
  const { control } = useAutomationFormContext();

  const protectSetUnits = useMerchantPaidProtectUnits();

  const selectOptions =
    protectSetUnits.data?.map((v) => ({
      value: `${v.id}`,
      label: formatter.currency(v.chargeAmount, 'USD'),
    })) ?? [];

  return (
    <Controller
      control={control}
      name="event.params.shipProtectUnitId"
      render={({ field: f, fieldState }) => (
        <SimpleSelect
          label="Fixed Amount"
          details="The amount to charge to protect each eligible order."
          options={selectOptions}
          onChange={(next) => f.onChange(Number.parseInt(next, 10))}
          value={f.value ? `${f.value}` : null}
          error={fieldState.error?.message}
        />
      )}
    />
  );
}
